// extracted by mini-css-extract-plugin
module.exports = {"icon":"TechnicalTable_icon__7fssb"};